import {Component, Input, OnInit} from '@angular/core';
import {ErrorDialogService} from '../services/error-dialog.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.css']
})
export class ErrorDialogComponent implements OnInit {
  /*private errorMessage: any;*/
  @Input() errorMessage: string;

  constructor(private errorDialogService: ErrorDialogService, private modalService: NgbActiveModal) { }

  ngOnInit() {
  }
  ok() {
    this.modalService.close(this.errorMessage);
  }
}
